module.exports = __webpack_public_path__ + "img/e2ebec9.png";